import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import useShortcuts from '../../hooks/useShortcuts'
import { useQuickWidgetActions } from '../../hooks/useQuickWidgetActions'
import { QuickWidgetTypes } from '../../reducer/user.reducer'
import { selectIsEmbedded } from '../../selectors/device'
import { ShortcutsCategories, ShortcutType } from './Shortcuts.types'
import { QuickWidgetShortcutsKeyName } from './ShortcutsKeymap'

/**
 * Registers quick-widget shortcuts at app level so they stay bound on first load
 * instead of waiting on the right-sidebar menu to mount / re-register.
 */
const QuickWidgetShortcutsRegister = () => {
    const isEmbedded = useSelector(selectIsEmbedded)
    const { handleToggle, toggleWidget } = useQuickWidgetActions()

    const shortcuts: ShortcutType = useMemo(() => ({
        [QuickWidgetShortcutsKeyName.showHideQuickWidgets]: handleToggle,
        [QuickWidgetShortcutsKeyName.openQuickWidgetMarketDepth]: () => toggleWidget(QuickWidgetTypes.MARKET_DEPTH),
        [QuickWidgetShortcutsKeyName.openQuickWidgetOrders]: () => toggleWidget(QuickWidgetTypes.ORDER),
        [QuickWidgetShortcutsKeyName.openQuickWidgetPositions]: () => toggleWidget(QuickWidgetTypes.POSITION),
        [QuickWidgetShortcutsKeyName.openQuickTradeWidget]: () => toggleWidget(QuickWidgetTypes.QUICK_TRADE)
    }), [handleToggle, toggleWidget])

    useShortcuts(ShortcutsCategories.QUICK_WIDGETS, shortcuts, !isEmbedded)
}

export default QuickWidgetShortcutsRegister
